// hooks/site/reducer.js
export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_SITES: 'SET_SITES',
    SET_SELECTED_SITE: 'SET_SELECTED_SITE',
    ADD_SITE: 'ADD_SITE',
    UPDATE_SITE: 'UPDATE_SITE',
    DELETE_SITE: 'DELETE_SITE',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE',
    SET_ALL_SITES: 'SET_ALL_SITES'
};

export const initialState = {
    sites: [],
    selectedSite: null,
    loading: false,
    error: null,
    filter: {
        name: null,
        status: null,
        location: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'createdAt',
        direction: 'desc'
    },
    lastUpdated: null,
    districtId: null
};

export const siteReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_SITES:
            return {
                ...state,
                sites: action.payload.content,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || action.payload.length,
                    page: action.payload.number || 0
                },
                lastUpdated: new Date().toISOString(),
                loading: false
            };
        case ACTIONS.SET_ALL_SITES:
            return {
                ...state,
                sites: action.payload,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_SELECTED_SITE:
            return {
                ...state,
                selectedSite: action.payload,
                loading: false
            };

        case ACTIONS.ADD_SITE:
            return {
                ...state,
                sites: [action.payload, ...state.sites],
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.UPDATE_SITE:
            return {
                ...state,
                sites: state.sites.map((site) => (site.id === action.payload.id ? action.payload.data : site)),
                selectedSite: state.selectedSite?.id === action.payload.id ? action.payload.data : state.selectedSite,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.DELETE_SITE:
            return {
                ...state,
                sites: state.sites.filter((site) => site.id !== action.payload),
                selectedSite: state.selectedSite?.id === action.payload ? null : state.selectedSite,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};
